import React from 'react';
import OnboardingRedirect from '@/components/payments/onboarding-redirect';
import Layout from '@/components/layout/main-layout';
import {useParams} from 'react-router-dom';
import {EventFormMode} from '@/types/event';

const OnboardingRedirectPage: React.FC = () => {
  const {mode, eventId} = useParams();
  return (
    <Layout>
      <OnboardingRedirect mode={mode as EventFormMode} eventId={eventId} />
    </Layout>
  );
};

export default OnboardingRedirectPage;
